import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import { PlaceholderWrapper, PlaceholderBody, PlaceholderFooter } from '.';
import PlaceholderImage from './activate-returns-placeholder.svg';
import { useEnhancedReturnRouteMatch } from '../../../../../store/returns/returns.helpers';
import Global from '../../../../../store/global-selectors';
import { ENHANCED_RETURNS_MODAL_STORE_ACTIVATION_BASE_PATH } from '../../../../settings/enhanced-returns/activation-modal/modal/enhanced-returns-activation-step-detective';
import { useTrackWorkflow, WorkflowSteps } from '../../../../../tracking/use-workflow-tracking';
import { EventSourceStrings, Workflows } from '../../../../../tracking/tracking-constants';
import { linkIDs } from '../../../../../services/link-service/links';
import { getLink } from '../../../../../services/link-service';

import messages from './messages';
import styles from './styles.module.less';

export const ActivateReturnsGridPlaceholder = () => {
  const intl = useIntl();
  const history = useHistory();
  const { storeGuid } = useEnhancedReturnRouteMatch();
  const stores = useSelector(Global.selectSellerActiveStores);
  const store = stores.find((s) => s.storeGuid === storeGuid);
  const trackActivateEnhancedReturns = useTrackWorkflow(Workflows.ACTIVATE_ENHANCED_RETURNS_FLOW);
  const supportCountry = useSelector((state) => Global.selectSellerSupportCountry(state));
  const helpArticleHref = getLink(linkIDs.EnhancedReturns, supportCountry, intl.locale);

  // TODO: refactor activation modal to use partial route matching
  const onClick = () => {
    trackActivateEnhancedReturns(WorkflowSteps.START, {
      source: EventSourceStrings.RETURNS_GRID_PLACEHOLDER,
    });

    history.push(`${ENHANCED_RETURNS_MODAL_STORE_ACTIVATION_BASE_PATH}/${storeGuid}`);
  };

  return (
    <PlaceholderWrapper>
      <img alt={intl.formatMessage(messages.returnDetailsAltText)} className={styles['activate-returns-image']} src={PlaceholderImage} />
      <PlaceholderBody>
        <Text
          formattedMessageValues={{
            storeName: store.name,
          }}
          textType={TextType.H2}
          value={messages.header}
        />
        <Text textType={TextType.Paragraph} value={messages.description} />
      </PlaceholderBody>
      <PlaceholderFooter>
        <Button className={styles.ctaButton} onClick={onClick} theme='primary'>
          <FormattedMessage {...messages.activateButton} />
        </Button>
        <Button href={helpArticleHref} theme='secondary'>
          <FormattedMessage {...messages.learnMoreButton} />
        </Button>
      </PlaceholderFooter>
    </PlaceholderWrapper>
  );
};
